import * as React from "react";
import { dateFormat, phoneFix } from "../../../../core/validation/validate";
import { trimString } from "../../../helpers/Utils";

export const TextBox = ({ value, handleChange, disabled, column }) => {
	const onChange = (event) => {
		const paste = event?.clipboardData?.getData("text");
		let value = paste ?? event.target.value;

		if (column?.extra?.valueType?.toUpperCase() === "PHONE") {
			value = phoneFix(value);
		}
		if (column?.extra?.valueType?.toUpperCase() === "DATEMONTHANDYEAR") {
			value = dateFormat(value);
		}
		event.target.value = value;

		handleChange(trimString(column.maxLength, value));
		// this.throttledChange(value);
	};

	return (
		<input
			type="text"
			className="form-control editor edit-text"
			defaultValue={value}
			disabled={disabled}
			onChange={onChange}
		/>
	);
};
